import './07.scss';

const autoCompleteLink = {
  name: "Dr Affiliate Link",
  // The prefix that triggers this completer
  triggerPrefix: ";",
  options: localStorage.getItem('affiliate-links') ? JSON.parse(localStorage.getItem('affiliate-links')) : [],
  //isDebounced: true,
  getOptionLabel: ( option ) => (
    <span>
        { option.title }
    </span>
  ),
  // Declares that options should be matched by their name
  getOptionKeywords: ( option ) => [ option.title ],
  // Declares that the Grapes option is disabled
  //isOptionDisabled: ( option ) => option.name === 'Grapes',
  // Declares completions should be inserted as abbreviations
  getOptionCompletion: ( option ) => (
    <a href={option.cloaked_url} className="dr_affiliate-links">{ option.title }</a>
  ),
};

// Our filter function
function appendautoCompleteLink( completers, blockName ) {
	return blockName === 'core/paragraph' ||
		blockName === 'core/heading' ||
		blockName === 'core/quote' ||
		blockName === 'core/list' ||
		blockName === 'core/verse' ||
		blockName === 'core/list' ?
		[ ...completers, autoCompleteLink ] :
		completers;
}

// Adding the filter
wp.hooks.addFilter(
	'editor.Autocomplete.completers',
	'dr-affiliate/links',
	appendautoCompleteLink
);